import type { ReactElement, SVGProps } from "react";

export function ChevronRightIcon(props: SVGProps<SVGSVGElement>): ReactElement {
  const { fill = "#16181D", stroke = "#16181D", ...restProps } = props;

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M5.22428 3.20516L9.59995 7.59999L5.19095 11.9948L5.98328 12.8L11.2 7.58332L6.01662 2.39999L5.22428 3.20516Z"
        fill={fill}
        stroke={stroke}
        strokeWidth="0.5"
      />
    </svg>
  );
}
